<template>
    <v-app>
        <v-navigation-drawer v-model="drawer" app clipped>
            <v-list dense>
            <v-list-item @click="navExceptions"  v-show="this.$global.login.loggedIn">
                <v-list-item-action>
                <v-icon color="grey darken-1">mdi-alert-decagram</v-icon>
                </v-list-item-action>
                <v-list-item-title class="grey--text text--darken-1">Exceptions</v-list-item-title>
            </v-list-item>
            <v-list-item @click="navFirms" v-show="this.$global.login.loggedIn">
                <v-list-item-action>
                <v-icon color="grey darken-1">mdi-hexagon</v-icon>
                </v-list-item-action>
                <v-list-item-title class="grey--text text--darken-1">Firms</v-list-item-title>
            </v-list-item>
            <v-list-item @click="navLicenses"  v-show="this.$global.login.loggedIn">
                <v-list-item-action>
                <v-icon color="grey darken-1">mdi-barcode</v-icon>
                </v-list-item-action>
                <v-list-item-title class="grey--text text--darken-1">Licenses</v-list-item-title>
            </v-list-item>
            <!--
            <v-list-item @click="navSettings" v-show="this.$global.login.loggedIn">
                <v-list-item-action>
                <v-icon color="grey darken-1">mdi-more</v-icon>
                </v-list-item-action>
                <v-list-item-title class="grey--text text--darken-1">Settings</v-list-item-title>
            </v-list-item>
            <v-list-item @click="navUsage" v-show="this.$global.login.loggedIn">
                <v-list-item-action>
                <v-icon color="grey darken-1">mdi-chart-arc</v-icon>
                </v-list-item-action>
                <v-list-item-title class="grey--text text--darken-1">Usage</v-list-item-title>
            </v-list-item>
            -->
            <v-list-item @click="navUsers"  v-show="this.$global.login.loggedIn">
                <v-list-item-action>
                <v-icon color="grey darken-1">mdi-account-circle</v-icon>
                </v-list-item-action>
                <v-list-item-title class="grey--text text--darken-1">Users</v-list-item-title>
            </v-list-item>
            <v-subheader class="mt-3 grey--text text--darken-1">USER</v-subheader>
            <v-list-item @click="navLogin">
                <v-list-item-action>
                <v-icon color="grey darken-1">mdi-logout</v-icon>
                </v-list-item-action>
                <v-list-item-title class="grey--text text--darken-1">Logout</v-list-item-title>
            </v-list-item>
            </v-list>
            <v-footer absolute class="text-center caption">
                <v-col >
                    <v-row>
                        {{version}}
                    </v-row>
                    <v-row>
                        {{this.$global.login.userDescription}}
                    </v-row>
                    <v-row fluid>
                        {{this.$global.login.email}}
                    </v-row>
                </v-col>
            </v-footer>
        </v-navigation-drawer>

    <v-app-bar app color="primary" dark clipped-left>
        <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
        <h2 v-html="title"></h2>
        <v-spacer></v-spacer>
        <div class="d-flex align-center">
            <v-img class="shrink mr-2" contain src="images/Draftworx.png" transition="scale-transition" width="160"/>
        </div>
    </v-app-bar>

    <v-content>
        <router-view class="ma-4"/>
    </v-content>
    <v-dialog v-model="confirm.show" max-width="400">
            <v-card>
                <v-card-title class="headline">{{ confirm.title }}</v-card-title>
                <v-card-text>
                    {{ confirm.text }}
                    <br/>
                    <b>{{ confirm.value }}</b>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="onConfirm(false)">Cancel</v-btn>
                    <v-btn color="primary" @click="onConfirm(true)">Yes</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="prompt.show" max-width="400">
            <v-card>
                <v-card-title class="headline">{{ prompt.title }}</v-card-title>
                <v-card-text>
                    {{ prompt.text }}
                    <v-text-field v-model="prompt.value" @keyup.native="onPromptKey" clearable v-if="prompt.show" autofocus></v-text-field>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="onPromptClick(false)">Cancel</v-btn>
                    <v-btn color="primary" @click="onPromptClick(true)">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="processing.show" persistent width="300">
            <v-card color="primary" dark>
                <v-card-text>
                    {{ processing.text }}
                    <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-snackbar v-model="snack.show" top :color="snack.color" :multi-line="false" :timeout="snack.timeout" :vertical="true">
            <div class="title">{{ snack.title }}</div>
            <div class="subheading">{{ snack.text }}</div>
            <v-btn dark class="ma-2" @click="snack.show = false">
                OK
            </v-btn>
        </v-snackbar>
    </v-app>
</template>

<script>

export default {
    name: "App",
    components: {
    },

    data: () => ({
        drawer: false,
        title: "Client Manager",
        version: "V1.43",
        snack: {
            show: false,
            color: "primary",
            timeout: 6000,
            title: "Alert",
            text: "Message",
        },
        confirm: {
            show: false,
            title: "Confirm",
            text: "Message",
            id: 0,
        },
        prompt: {
            show: false,
            title: "Confirm",
            text: "Message",
            id: 0,
        },
        processing: {
            show: false,
            text: "Please stand by",
        },
    }),

    mounted() {
        // Listen for notifcation messages.
        this.$root.$on("DX_Notification", options => this.globalAlert(options));
        // Listen for confirm messages.
        this.$root.$on("DX_Confirm", options => this.globalConfirm(options));
        // Listen for prompt messages.
        this.$root.$on("DX_Prompt", options => this.globalPrompt(options));
        // Listen for processing messages.
        this.$root.$on("DX_Process", options => this.globalProcess(options));
    },

    methods: {
        // A global alert system triggered by this.$alert().
        globalAlert(options) {
            this.snack.title = options.title || "Alert";
            this.snack.text = options.message || "";
            this.snack.color = options.type || "info";
            this.snack.show = true;
        },
        // A global confirm system triggered by this.$confirm().
        globalConfirm(options) {
            this.confirm.title = options.title || "Confirm?";
            this.confirm.text = options.message || "";
            this.confirm.value = options.value || "";
            this.confirm.show = true;
        },
        onConfirm(result) {
            this.confirm.show = false;
            this.$root.$emit("DX_Confirm_Result", result);
        },
        // A global confirm system triggered by this.$prompt().
        globalPrompt(options) {
            this.prompt.title = options.title || "Enter value";
            this.prompt.text = options.message || "";
            this.prompt.value = options.value || "";
            this.prompt.show = true;
        },
        onPromptKey(evt) {
            if (evt.key === "Enter") this.onPromptClick(true);
            else if (evt.key === "Escape") this.onPromptClick(false);
        },
        onPromptClick(result) {
            this.prompt.show = false;
            this.$root.$emit("DX_Prompt_Result", { Action: result, Value: this.prompt.value });
        },
        // A global confirm system triggered by this.$prompt().
        globalProcess(options) {
            this.prompt.text = options.message || "";
            this.prompt.show = options.show !== false;
        },
        navExceptions() {
            this.$router.push({ name: "exceptions" });
            this.title = "Exceptions";
            this.drawer = false;
        },
        navFirms() {
            this.$router.push({ name: "firms" });
            this.title = "Firm Manager";
            this.drawer = false;
        },
        navLicenses() {
            this.$router.push({ name: "licenses" });
            this.title = "License Manager";
            this.drawer = false;
        },
        navSettings() {
            this.$router.push({ name: "settings" });
            this.title = "Settings Manager";
            this.drawer = false;
        },
        navUsage() {
            this.$router.push({ name: "usage" });
            this.title = "Usage Manager";
            this.drawer = false;
        },
        navUsers() {
            this.$router.push({ name: "users" });
            this.title = "User Manager";
            this.drawer = false;
        },
        navLogin() {
            this.$global.login.userDescription = "";
            this.$global.login.loggedIn = false;
            this.$global.login.email = "";
            this.$router.push({ name: "login" });
            this.title = "Client Manager";
            this.drawer = false;
        },
    },
};
</script>

<style>
.theme--light.v-data-table tbody tr:nth-of-type(even) {
    background-color: rgba(0, 0, 0, .03);
}
.theme--dark.v-data-table tbody tr:nth-of-type(even) {
    background-color: rgba(0, 0, 0, .5);
}
.v-data-table--dense td {
    height: 28px !important;
}
</style>
